let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ybrxl")).then(() => parcelRequire('1fWHc'));